/**
 * The base colors for the Kai.
 * You can add new color using this file.
 * You can customized the colors for the entire project using this file.
 */

const colors = {
  background: {
    default: "#FFFFFF",
    sidenav: "#1f283e",
    card: "#202940",
  },

  text: {
    main: "#000",
    focus: "#2c3c58",
    idle: "#D9D9D9",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },
  disable: {
    main: "#b5b5b5",
  },

  primary: {
    main: "#373737",
    focus: "#686868",
  },

  secondary: {
    main: "#26bbb3",
    focus: "#26bbb3",
  },

  info: {
    main: "#1A73E8",
    focus: "#1662C4",
  },

  success: {
    main: "#4CAF50",
    focus: "#67bb6a",
  },

  warning: {
    main: "#FAAF64",
    focus: "#fc9d26",
  },

  error: {
    main: "#F44335",
    focus: "#f65f53",
  },

  light: {
    main: "#F6F9FA",
    focus: "#F6F9FA",
  },

  dark: {
    main: "#000",
    focus: "#2c3c58",
  },

  grey: {
    100: "#f8f9fa",
    200: "#F5F5F5",
    300: "#dee2e6",
    400: "#FDFEFF",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },
  borderColor: "#9C9C9C",

  gradients: {
    background: {
      main: "#f4edff",
      state: "#fff3e3",
    },
    primary: {
      main: "#373737",
      state: "#000",
    },

    secondary: {
      main: "#26bbb3",
      state: "#209c8b",
    },

    info: {
      main: "#348db3",
      state: "#348db3",
    },

    success: {
      main: "#66BB6A",
      state: "#43A047",
    },

    warning: {
      main: "#FAAF64",
      state: "#FB8C00",
    },

    error: {
      main: "#EF5350",
      state: "#E53935",
    },

    light: {
      main: "#EBEFF4",
      state: "#CED4DA",
    },

    dark: {
      main: "#42424a",
      state: "#191919",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: {
      background: "#FCE8F7",
      text: "#A46195",
    },

    secondary: {
      background: "#B5B5B5",
      text: "#FFFFFF",
    },

    info: {
      background: "#aecef7",
      text: "#095bc6",
    },

    success: {
      background: "#D4F0F2",
      text: "#227F85",
    },

    warning: {
      background: "#ffd59f",
      text: "#c87000",
    },

    error: {
      background: "#fcd3d0",
      text: "#f61200",
    },

    light: {
      background: "#ffffff",
      text: "#c7d3de",
    },
    draft: {
      background: "#FFFFE8",
      text: "#5F6031",
    },
    dark: {
      background: "#8097bf",
      text: "#1e2e4a",
    },
  },

  coloredShadows: {
    primary: "#e91e62",
    secondary: "#110e0e",
    info: "#00bbd4",
    success: "#4caf4f",
    warning: "#ff9900",
    error: "#f44336",
    light: "#adb5bd",
    dark: "#404040",
  },

  inputBorderColor: "#B5B5B5",

  draggableShade: "#DCEEF4",
  draggableShadeBorder: "#9BB8C1",

  templateCardColor: {
    main: "#e3f5fc",
    focus: "#ffffffb5",
  },

  tabs: {
    main: "#E0EDF1",
    indicator: { boxShadow: "#ddd" },
  },
};

export default colors;
